import { useEffect, } from "react";
import { Navigate, Route } from "react-router-dom";
import { setAuthorization } from "../helpers/api_helper";
import { useDispatch } from "react-redux";
import { logoutUser } from "slices/thunk";

const AuthProtected = (props: any) => {
  const dispatch = useDispatch<any>();
  const token = localStorage.getItem("token");
  const userProfile = localStorage.getItem("authPOSUser")
  useEffect(() => {
    if (userProfile && token) {
      setAuthorization(token);
    } else if (!userProfile || !token) {
      dispatch(logoutUser());
    }
  }, [token, userProfile, dispatch]);


  if (!userProfile || !token) {
    return <Navigate to="/login" replace />;
  }

  return <>{props.children}</>;
};


const AccessRoute = ({ component: Component, ...rest }: any) => {
  return (
    <>
      <Route
        {...rest}
        render={(props: any) => {
          return (<> <Component {...props} /> </>);
        }}
      />
    </>
  );
};

export { AuthProtected, AccessRoute };